module.exports = __webpack_public_path__ + "img/domains-step-3.ru.e357945f.png";